/* eslint-disable jsx-a11y/anchor-is-valid */
import { Icon } from "../icon";
import "./forbidden-page.scss";

export const ForbiddenPage = () => {
  return (
    <div className="forbidden-page">
      <Icon.FolderWarningFill />
      <h4>Cảnh báo</h4>
      <h5>Truy cập không hợp lệ</h5>
      <p>
        Bạn không có quyền truy cập vào chức năng này. Vui lòng liên hệ <a>ADMIN</a> để được hỗ trợ
      </p>
    </div>
  );
};
